import { FC } from 'react';
import {
  getFieldValue,
  getSelectedOptionValues,
  isAllDates,
  SingleFilterHeaderFieldControlProps,
} from './helpers';
import { DateRangeValue } from '@/lib/helpers';
import Select from '@/components/form/select';
import CheckboxMulti from '@/components/form/checkbox-multi';
import DateRangeInput from '@/components/form/date-range';
import TextInput from '@/components/form/text-input';

const FilterField: FC<SingleFilterHeaderFieldControlProps> = ({
  field,
  values,
  setValueForColumn,
  setColumnToDefault,
}) => {
  const { columnName, control, options = [], minDate, maxDate } = field;
  const currentValue = getFieldValue(values, columnName);

  switch (control) {
    case 'date-range': {
      const rangeVal = (currentValue as DateRangeValue) ?? [null, null];
      return (
        <DateRangeInput
          name={`filter-header-${columnName}-date-range`}
          label="From Date"
          endLabel="To Date"
          value={rangeVal}
          onChange={(value) => {
            if (isAllDates(value)) {
              setColumnToDefault(columnName);
            } else {
              setValueForColumn(columnName, value);
            }
          }}
          size="x-small"
          minDate={minDate}
          maxDate={maxDate}
        />
      );
    }

    case 'select-multi': {
      const currentArr = Array.isArray(currentValue) ? (currentValue as string[]) : [];
      const selectedOptionValues = getSelectedOptionValues(currentArr, options);
      return (
        <CheckboxMulti
          name={`filter-header-${columnName}`}
          options={options}
          value={selectedOptionValues}
          size="x-small"
          onChange={(value) => {
            if (!value.length) {
              setColumnToDefault(columnName);
              return;
            }

            setValueForColumn(columnName, value);
          }}
        />
      );
    }

    case 'text': {
      const textVal = (currentValue as string) ?? '';
      return (
        <TextInput
          name={`filter-header-${columnName}`}
          value={textVal}
          onChange={(value) => {
            if (String(value).trim() === '') {
              setColumnToDefault(columnName);
            } else {
              setValueForColumn(columnName, value);
            }
          }}
          size="small"
        />
      );
    }

    case 'select':
    default: {
      const singleVal = (currentValue as string) ?? '';
      return (
        <Select
          name={`filter-header-${columnName}`}
          options={options}
          value={singleVal}
          onChange={(value) =>
            value === '' ? setColumnToDefault(columnName) : setValueForColumn(columnName, value)
          }
          size="x-small"
        />
      );
    }
  }
};

export default FilterField;
